import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://qkmjdpomdkvmxnzcvqin.supabase.co';
const supabaseAnonKey = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFrbWpkcG9tZGt2bXhuemN2cWluIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzY2Mjc5NTMsImV4cCI6MjA5MjIwMzk1M30.nVd2gbT-kSidQsXSgnK9zML5eQeU-2ag7fTt9JZGdqA';

export const supabase = createClient(supabaseUrl, supabaseAnonKey)